import { BaseModel } from '../../../models/base-model'
import {
  AnswerChoiceGroup,
  Explanation,
  Topic,
  QuestionType,
  QuestionPrompt,
  QuestionMetadatum,
  QuestionContext,
  UserQuestion,
  AnswerChoice,
} from '../'

export class Question extends BaseModel {
  public difficulty: number = null
  public name: string = ''
  public questionPrompts: QuestionPrompt[]
  public status: string = ''
  public answerChoiceGroups: AnswerChoiceGroup[] = []
  public explanations: Explanation[] = []
  public minorTopics: Topic[] = []
  public majorTopic: Topic
  public questionType: QuestionType
  public createdAt: Date
  public questionContext: QuestionContext
  public questionMetadatum: QuestionMetadatum
  public question: UserQuestion
  public testLineId: string

  public get firstAnswerChoiceGroup() {
    return this.answerChoiceGroups[0]
  }

  public get answerChoices(): AnswerChoice[] {
    return this.answerChoiceGroups
      .reduce((previousArray, answerChoiceGroup) => previousArray.concat(answerChoiceGroup.answerChoices), [])
  }

  public addAnswerChoiceGroup(answerChoiceGroup: AnswerChoiceGroup) {
    const lastSort = this.answerChoiceGroups[this.answerChoiceGroups.length - 1].sort
    answerChoiceGroup.sort = lastSort + 1
    this.answerChoiceGroups.push(answerChoiceGroup)
  }

  public getMinorTopicByIndex(index): Topic {
    return this.minorTopics[index] || this._nullTopic()
  }

  public getQuestionPrompt(key: string): QuestionPrompt {
    return this.questionPrompts.find((questionPrompt) => questionPrompt.key === key)
  }

  public isAnswerChoiceCorrect(choiceId: string) {
    return this.answerChoiceGroups.some((answerChoiceGroup) => answerChoiceGroup.isAnswerChoiceCorrect(choiceId))
  }

  public getVideoExplanations() {
    return (this.explanations || []).filter((explanation) => explanation.isVideoExplanation())
  }

  public getMetadata(key: string) {
    return this.questionMetadatum ? this.questionMetadatum.getValue(key) : null
  }

  private _nullTopic() {
    const topic = new Topic()
    topic.id = ''
    return topic
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/question/question.ts